"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require("react-router");

var _TransportDocumentUtil = require("../../utils/TransportDocumentUtil");

var util = _interopRequireWildcard(_TransportDocumentUtil);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

require("moment-duration-format");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = require("jquery");
$.DataTable = require("datatables.net");
//    require( 'datatables.net-buttons' )( window, $ );
//   require('datatables.net-buttons/js/buttons.html5')(window, $);
var buttons = require("datatables.net-buttons");
// window.JSZip = require('jszip')
require("datatables.net-buttons/js/buttons.html5.js");

var TransportDocumentsPanel = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(TransportDocumentsPanel, _Component);

  function TransportDocumentsPanel() {
    (0, _classCallCheck3.default)(this, TransportDocumentsPanel);
    return (0, _possibleConstructorReturn3.default)(this, (TransportDocumentsPanel.__proto__ || (0, _getPrototypeOf2.default)(TransportDocumentsPanel)).apply(this, arguments));
  }

  (0, _createClass3.default)(TransportDocumentsPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {

      $(document).ready(function () {
        var _$$DataTable;

        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex) {
          var isBeforeOrSame = function isBeforeOrSame(date, date2) {
            return date.isBefore(date2) || date.isSame(date2);
          };
          var isAfterOrSame = function isAfterOrSame(date, date2) {
            return date.isAfter(date2) || date.isSame(date2);
          };
          var isValidDate = function isValidDate(input) {
            var betterInput = input.trim();
            if (betterInput === "") {
              return true;
            }
            if (/^[0-9]{1,2}\.[0-9]{1,2}$/i.test(betterInput)) {
              return true;
            }
            if (/^[0-9]{1,2}\.[0-9]{1,2}\.[0-9]{4}$/i.test(betterInput)) {
              return true;
            }
            return false;
          };

          if (!isValidDate($("#min").val()) || !isValidDate($("#max").val())) {
            return false;
          }
          var format = "DD.MM.YYYY";
          var min = (0, _moment2.default)($("#min").val(), format);
          var max = (0, _moment2.default)($("#max").val(), format);
          var date = (0, _moment2.default)(data[1], format) || 0;

          if (!min.isValid() && !max.isValid() || !min.isValid() && isBeforeOrSame(date, max) || !max.isValid() && isAfterOrSame(date, min) || isAfterOrSame(date, min) && isBeforeOrSame(date, max)) {
            return true;
          }
          return false;
        });
        var table = $("#transport-documents").DataTable((_$$DataTable = {
          scrollY: 400,
          scrollX: true,
          paging: false,
          columns: [{ data: "siirtoasiakirja" }, { data: "pvm" }, { data: "projekti" }, { data: "kuljetusliike" }, { data: "kuljettaja" }, { data: "rekisterinumero" }, { data: "tyonumero" }, { data: "lahtopaikka" }, { data: "kuormaus_alkoi" }, {
            data: "ajo_alkoi", render: function render(data, type, row) {
              return type === "export" ? data.replace(/'/g, "") : data;
            }
          }, { data: "kuormaus_kesto" }, { data: "kuljetusmatka_km" }, { data: "vastaanottopaikka" }, { data: "purku_alkoi" }, { data: "purku_valmis" }, { data: "purku_kesto" }, { data: "muistiinpanot" }, { data: "ajon_kesto" }, { data: "kokonaisaika" }, { data: "paluu" }, { data: "aines" }, { data: "aineen_maara(t)" }, { data: "ewc_koodi" }],
          dom: "Bfrtip"
        }, (0, _defineProperty3.default)(_$$DataTable, "dom", "Brtip"), (0, _defineProperty3.default)(_$$DataTable, "order", [[0, "desc"]]), (0, _defineProperty3.default)(_$$DataTable, "buttons", [
        /*      {
                extend: 'excelHtml5',
                text: 'Excel',
                title: '',
                customize: function (xlsx) {
                  var sheet = xlsx.xl.worksheets['sheet1.xml'];
                  //    $('row:first c', sheet).remove();
                  //    $('row:first c', sheet).remove();
                  $('row:first c', sheet).attr('s', '42');
                },
                exportOptions: { orthogonal: 'export' }
              }, */
        {
          extend: "copyHtml5",
          text: "Kopioi",
          title: "",
          exportOptions: { orthogonal: "export" }

        }, {
          extend: "csvHtml5",
          text: "CSV",
          title: "",
          exportOptions: { orthogonal: "export" }

        }, "pdfHtml5"]), (0, _defineProperty3.default)(_$$DataTable, "language", {
          search: "",
          searchPlaceholder: "Etsi...",
          zeroRecords: "Antamillasi hakuehdoilla ei löytynyt yhtään kuljetusta.",
          loadingRecords: "Ladataan kuljetuksia..",
          emptyTable: "Y-tunnuksen alta ei löytynyt kuljetuksia tai sinulla ei ole oikeuksia niiden katseluun.",
          infoFiltered: "",
          infoEmpty: "",
          info: "Näytetään kuljetukset _START_ - _END_ yhteensä _TOTAL_ kuljetuksesta.",
          paginate: {
            next: " Seuraava ",
            previous: " Edellinen ",
            first: " Ensimmäinen ",
            last: " Viimeinen "
          },
          aria: {
            sortAscending: ": activate to sort column ascending",
            sortDescending: ": activate to sort column descending"
          }
        }), (0, _defineProperty3.default)(_$$DataTable, "destroy", true), _$$DataTable));
        $("#min, #max").keyup(function () {
          table.draw();
        });
        $("#projekti").keyup(function () {
          table.column(2).search($("#projekti").val()).draw();
        });

        $("#kuljettaja").keyup(function () {
          table.column(4).search($("#kuljettaja").val()).draw();
        });
        $("#rekisteri").keyup(function () {
          table.column(5).search($("#rekisteri").val()).draw();
        });
        $("#tyonumero").keyup(function () {
          table.column(6).search($("#tyonumero").val()).draw();
        });
        $("#lahtopaikka").keyup(function () {
          table.column(7).search($("#lahtopaikka").val()).draw();
        });
        $("#vastaanotto").keyup(function () {
          table.column(12).search($("#vastaanotto").val()).draw();
        });
        $("#aines").keyup(function () {
          table.column(20).search($("#aines").val()).draw();
        });
        $("#ewc").keyup(function () {
          table.column(22).search($("#ewc").val()).draw();
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "row" },
        _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "h1",
            { className: "h3" },
            "Kuljetusraportti"
          ),
          _react2.default.createElement(
            "p",
            null,
            "Ta\u0308lla\u0308 sivulla na\u0308et kuljetusraportit ja digitaaliset siirtoasiakirjat ajamistasi ajoista. Ylla\u0308pita\u0308ja\u0308 -profiilit na\u0308keva\u0308t kaikki y-tunnuksen nimissa\u0308 luodut raportit ja siirtoasiakirjat."
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "h2",
            { className: "h4 form-title form-title-js" },
            "Ajot"
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "col col-xs-12 transport-document-list" },
          _react2.default.createElement(
            "div",
            { className: "row", style: { padding: "5px" } },
            _react2.default.createElement(
              "div",
              { className: "col col-xs-2 searchField" },
              "Aikav\xE4lihaku:"
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "row", style: { padding: "5px" } },
            _react2.default.createElement(
              "div",
              { className: "col col-xs-2 searchField" },
              _react2.default.createElement("input", { type: "text", id: "min", name: "min" })
            ),
            _react2.default.createElement(
              "div",
              { style: { padding: "10px", textAlign: "center", fontWeight: "bold" } },
              "-"
            ),
            _react2.default.createElement(
              "div",
              { className: "col col-xs-2 searchField" },
              _react2.default.createElement("input", { type: "text", id: "max", name: "max" })
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "row", style: { padding: "5px" } },
            _react2.default.createElement(
              "div",
              { className: "col col-xs-2 searchField" },
              "Projekti:",
              _react2.default.createElement("input", { type: "text", id: "projekti", name: "projekti", placeholder: "Etsi..." })
            ),
            _react2.default.createElement(
              "div",
              { className: "col col-xs-2 searchField" },
              "Kuljettaja:",
              _react2.default.createElement("input", { type: "text", id: "kuljettaja", name: "kuljettaja", placeholder: "Etsi..." })
            ),
            _react2.default.createElement(
              "div",
              { className: "col col-xs-2 searchField" },
              "Rekisterinumero:",
              _react2.default.createElement("input", { type: "text", id: "rekisteri", name: "rekisteri", placeholder: "Etsi..." })
            ),
            _react2.default.createElement(
              "div",
              { className: "col col-xs-2 searchField" },
              "Ty\xF6numero:",
              _react2.default.createElement("input", { type: "text", id: "tyonumero", name: "tyonumero", placeholder: "Etsi..." })
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "row", style: { padding: "5px" } },
            _react2.default.createElement(
              "div",
              { className: "col col-xs-2 searchField" },
              "L\xE4ht\xF6paikka:",
              _react2.default.createElement("input", { type: "text", id: "lahtopaikka", name: "lahtopaikka", placeholder: "Etsi..." })
            ),
            _react2.default.createElement(
              "div",
              { className: "col col-xs-2 searchField" },
              "Vastaanottopaikka:",
              _react2.default.createElement("input", { type: "text", id: "vastaanotto", name: "vastaanotto", placeholder: "Etsi..." })
            ),
            _react2.default.createElement(
              "div",
              { className: "col col-xs-2 searchField" },
              "Aines:",
              _react2.default.createElement("input", { type: "text", id: "aines", name: "aines", placeholder: "Etsi..." })
            ),
            _react2.default.createElement(
              "div",
              { className: "col col-xs-2 searchField" },
              "EWC-koodi:",
              _react2.default.createElement("input", { type: "text", id: "ewc", name: "ewc", placeholder: "Etsi..." })
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "row", style: { padding: "5px" } },
            _react2.default.createElement(
              "div",
              { className: "col col-xs-12 saveText" },
              "Painamalla ",
              _react2.default.createElement(
                "b",
                null,
                "Kopio"
              ),
              ", siirr\xE4t kuljetusraporttiin valitsemasi tiedot leikep\xF6yd\xE4lle, josta voit liitt\xE4\xE4 ne haluamaasi ohjelmaan, esim. Exceliin. Painamalla ",
              _react2.default.createElement(
                "b",
                null,
                "CSV"
              ),
              "-painiketta, muodostat CSV-tiedoston valitsemistasi tiedoista."
            )
          ),
          _react2.default.createElement(
            "table",
            { className: "table grid dataTable", id: "transport-documents", style: { boxSizing: "content-box" } },
            _react2.default.createElement(
              "thead",
              null,
              _react2.default.createElement(
                "tr",
                null,
                _react2.default.createElement(
                  "th",
                  null,
                  "Siirtoasiakirja:"
                ),
                _react2.default.createElement(
                  "th",
                  null,
                  "Pvm:"
                ),
                _react2.default.createElement(
                  "th",
                  null,
                  "Projekti:"
                ),
                _react2.default.createElement(
                  "th",
                  null,
                  "Kuljetusliike:"
                ),
                _react2.default.createElement(
                  "th",
                  null,
                  "Kuljettaja:"
                ),
                _react2.default.createElement(
                  "th",
                  null,
                  "Rekisterinumero:"
                ),
                _react2.default.createElement(
                  "th",
                  null,
                  "Ty\xF6numero:"
                ),
                _react2.default.createElement(
                  "th",
                  null,
                  "L\xE4ht\xF6paikka:"
                ),
                _react2.default.createElement(
                  "th",
                  null,
                  "Kuormaus alkoi:"
                ),
                _react2.default.createElement(
                  "th",
                  null,
                  "Ajo alkoi:"
                ),
                _react2.default.createElement(
                  "th",
                  null,
                  "Kuormaus kesto:"
                ),
                _react2.default.createElement(
                  "th",
                  null,
                  "Kuljetusmatka (km):"
                ),
                _react2.default.createElement(
                  "th",
                  null,
                  "Vastaanottopaikka:"
                ),
                _react2.default.createElement(
                  "th",
                  null,
                  "Purku alkoi:"
                ),
                _react2.default.createElement(
                  "th",
                  null,
                  "Purku valmis:"
                ),
                _react2.default.createElement(
                  "th",
                  null,
                  "Purku kesto:"
                ),
                _react2.default.createElement(
                  "th",
                  null,
                  "Muistiinpanot:\xA0\xA0\xA0\xA0"
                ),
                _react2.default.createElement(
                  "th",
                  null,
                  "Ajon kesto:"
                ),
                _react2.default.createElement(
                  "th",
                  null,
                  "Kokonaisaika:"
                ),
                _react2.default.createElement(
                  "th",
                  null,
                  "Paluu:"
                ),
                _react2.default.createElement(
                  "th",
                  null,
                  "Aines:"
                ),
                _react2.default.createElement(
                  "th",
                  null,
                  "Aineen m\xE4\xE4r\xE4(t):"
                ),
                _react2.default.createElement(
                  "th",
                  null,
                  "EWC-koodi:"
                )
              )
            ),
            _react2.default.createElement(
              "tbody",
              null,
              this.renderTransports()
            )
          )
        )
      );
    }
  }, {
    key: "renderTransports",
    value: function renderTransports() {
      var _this2 = this;

      var _props = this.props,
          transportDocuments = _props.transportDocuments,
          soilTypes = _props.soilTypes,
          ewcCodes = _props.ewcCodes;


      return transportDocuments.map(function (transport, index) {
        var projectName = "Ei projektia";
        if (transport.project) {
          projectName = transport.project.name;
        }
        return _react2.default.createElement(
          "tr",
          { key: index, className: "transports-row-js" },
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement(
              _reactRouter.Link,
              {
                to: _this2.getPath(transport),
                target: "_blank" },
              transport.id
            )
          ),
          _react2.default.createElement(
            "td",
            null,
            _this2.createDateTime(transport.created_at)
          ),
          _react2.default.createElement(
            "td",
            null,
            projectName
          ),
          _react2.default.createElement(
            "td",
            null,
            transport.company.name
          ),
          _react2.default.createElement(
            "td",
            null,
            transport.user.first_name,
            " ",
            transport.user.last_name
          ),
          _react2.default.createElement(
            "td",
            null,
            transport.car.register_number
          ),
          _react2.default.createElement(
            "td",
            null,
            transport.work_number
          ),
          _react2.default.createElement(
            "td",
            null,
            transport.supplier.address,
            " ",
            transport.supplier.postal_code,
            " ",
            transport.supplier.postal_area
          ),
          _react2.default.createElement(
            "td",
            null,
            _this2.createTime(transport.loading_start_time)
          ),
          _react2.default.createElement(
            "td",
            null,
            _this2.createTime(transport.driving_start_time)
          ),
          _react2.default.createElement(
            "td",
            null,
            _this2.getLoadingDuration(transport)
          ),
          _react2.default.createElement(
            "td",
            null,
            util.formatRouteLength(transport)
          ),
          _react2.default.createElement(
            "td",
            null,
            transport.receiver.address,
            " ",
            transport.receiver.postal_code,
            " ",
            transport.receiver.postal_area
          ),
          _react2.default.createElement(
            "td",
            null,
            _this2.createTime(transport.unloading_start_time)
          ),
          _react2.default.createElement(
            "td",
            null,
            _this2.createTime(transport.unloading_end_time)
          ),
          _react2.default.createElement(
            "td",
            null,
            _this2.getUnloadingDuration(transport)
          ),
          _react2.default.createElement(
            "td",
            null,
            transport.extra_info
          ),
          _react2.default.createElement(
            "td",
            null,
            _this2.getTransportDuration(transport)
          ),
          _react2.default.createElement(
            "td",
            null,
            _this2.getTotalDuration(transport)
          ),
          _react2.default.createElement(
            "td",
            null,
            _this2.getTransportDurationWithReturn(transport)
          ),
          _react2.default.createElement(
            "td",
            null,
            util.getSoilTypeName(transport, soilTypes)
          ),
          _react2.default.createElement(
            "td",
            null,
            transport.soil.amount
          ),
          _react2.default.createElement(
            "td",
            null,
            util.getEwcCodeName(transport, ewcCodes)
          )
        );
      });
    }
  }, {
    key: "createDateTime",
    value: function createDateTime(timestamp) {
      return (0, _moment2.default)(timestamp).format("DD.MM.YYYY");
    }
  }, {
    key: "createTime",
    value: function createTime(timestamp) {
      return (0, _moment2.default)(timestamp).format("YYYY-MM-DD HH:mm:ss");
    }
    /*
      getLoadingDuration(transport) {
      var startTime = moment(transport.loading_start_time, "HH:mm:ss");
      var endTime = moment(transport.driving_start_time, "HH:mm:ss");
      var duration = moment.duration(endTime.diff(startTime));
      var hours = parseInt(duration.asHours());
      var minutes = parseInt(duration.asMinutes()) - hours * 60;
      return hours + ':' + minutes;
    }
    */

  }, {
    key: "getLoadingDuration",
    value: function getLoadingDuration(transport) {
      var endTime = transport.driving_start_time;
      var startTime = transport.loading_start_time;
      return _moment2.default.duration((0, _moment2.default)(endTime).diff(startTime)).format("h:mm:ss", { trim: false });
    }
  }, {
    key: "getTransportDuration",
    value: function getTransportDuration(transport) {
      var endTime = transport.unloading_start_time;
      var startTime = transport.driving_start_time;
      return _moment2.default.duration((0, _moment2.default)(endTime).diff(startTime)).format("h:mm:ss", { trim: false });
    }
  }, {
    key: "getUnloadingDuration",
    value: function getUnloadingDuration(transport) {
      var endTime = transport.unloading_end_time;
      var startTime = transport.unloading_start_time;
      return _moment2.default.duration((0, _moment2.default)(endTime).diff(startTime)).format("h:mm:ss", { trim: false });
    }
  }, {
    key: "getTotalDuration",
    value: function getTotalDuration(transport) {
      var endTime = transport.unloading_end_time;
      var startTime = transport.loading_start_time;
      return _moment2.default.duration((0, _moment2.default)(endTime).diff(startTime)).format("h:mm:ss", { trim: false });
    }
  }, {
    key: "getTransportDurationWithReturn",
    value: function getTransportDurationWithReturn(transport) {
      var unloadStart = transport.unloading_start_time;
      var driveStart = transport.driving_start_time;
      if (transport.invoice_return_trip) {
        return _moment2.default.duration((0, _moment2.default)(unloadStart).diff(driveStart)).format("h:mm", { trim: false });
      }
      return "Ei laskuteta";
    }
  }, {
    key: "getPath",
    value: function getPath(transportDocument) {
      return "/tulosta/ajot/" + transportDocument.token;
    }
  }]);
  return TransportDocumentsPanel;
}(_react.Component), _class.propTypes = {
  transportDocuments: _react.PropTypes.array,
  loadTransportDocuments: _react.PropTypes.func.isRequired,
  soilTypes: _react.PropTypes.array,
  user: _react.PropTypes.object,
  returnTrip: _react.PropTypes.object,
  auth: _react.PropTypes.object,
  ewcCodes: _react.PropTypes.array
}, _temp);
exports.default = TransportDocumentsPanel;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/transportdocuments/TransportDocumentsPanel.js
 ** module id = 1188
 ** module chunks = 0
 **/